"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionElement = exports.TextElement = exports.Title = exports.Message = exports.Container = exports.Dismiss = exports.Icon = exports.iconStyles = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var iconStyles = function iconStyles(_ref) {
  var _theme$brand, _theme$brand$colors, _theme$message;

  var theme = _ref.theme;
  return (0, _deepExtend["default"])({
    flexShrink: "0",
    objectFit: "contain",
    alignSelf: "center",
    padding: "2px",
    maxHeight: "40px !important",
    maxWidth: "40px !important",
    path: {
      fill: theme === null || theme === void 0 ? void 0 : (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary
    }
  }, theme === null || theme === void 0 ? void 0 : (_theme$message = theme.message) === null || _theme$message === void 0 ? void 0 : _theme$message.icon);
};

exports.iconStyles = iconStyles;

var Icon = _styledComponents["default"].img.withConfig({
  displayName: "styled__Icon",
  componentId: "sc-16x2xpi-0"
})(iconStyles);

exports.Icon = Icon;

var Dismiss = _styledComponents["default"].button.withConfig({
  displayName: "styled__Dismiss",
  componentId: "sc-16x2xpi-1"
})(function (_ref2) {
  var _theme$brand2, _theme$brand2$colors;

  var theme = _ref2.theme;
  return (0, _deepExtend["default"])({
    opacity: 0,
    cursor: "pointer",
    position: "absolute",
    top: -15,
    fontFamily: "\"Roboto\", monospace",
    right: -10,
    width: 25,
    height: 25,
    zIndex: 50,
    color: theme === null || theme === void 0 ? void 0 : (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$colors = _theme$brand2.colors) === null || _theme$brand2$colors === void 0 ? void 0 : _theme$brand2$colors.primary,
    background: "rgba(255, 255, 255, 0.8)",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
    transition: "opacity 100ms ease-in",
    padding: 3,
    border: "none",
    "&:hover": {
      background: "white"
    },
    borderRadius: "100%"
  }, theme === null || theme === void 0 ? void 0 : theme.dismiss);
});

exports.Dismiss = Dismiss;

var Container = _styledComponents["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-16x2xpi-2"
})(["width:100%;position:relative;&:hover ", "{opacity:1;}"], Dismiss);

exports.Container = Container;

var Message = _styledComponents["default"].div.withConfig({
  displayName: "styled__Message",
  componentId: "sc-16x2xpi-3"
})(function (_ref3) {
  var _theme$message2;

  var theme = _ref3.theme;
  return (0, _deepExtend["default"])({
    padding: 12,
    paddingRight: 0,
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "14px",
    alignSelf: "center",
    color: "var(--ci-text-color)",
    overflow: "hidden"
  }, theme === null || theme === void 0 ? void 0 : (_theme$message2 = theme.message) === null || _theme$message2 === void 0 ? void 0 : _theme$message2.contents);
});

exports.Message = Message;

var Title = _styledComponents["default"].div.withConfig({
  displayName: "styled__Title",
  componentId: "sc-16x2xpi-4"
})(function (_ref4) {
  var _theme$message3;

  var theme = _ref4.theme;
  return (0, _deepExtend["default"])({
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "19px",
    letterSpacing: "0em",
    textAlign: "left",
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitLineClamp: "1",
    WebkitBoxOrient: "vertical",
    color: "var(--ci-title-color)"
  }, (_theme$message3 = theme.message) === null || _theme$message3 === void 0 ? void 0 : _theme$message3.title);
});

exports.Title = Title;

var TextElement = _styledComponents["default"].div.withConfig({
  displayName: "styled__TextElement",
  componentId: "sc-16x2xpi-5"
})(function (_ref5) {
  var _theme$message4;

  var theme = _ref5.theme;
  return (0, _deepExtend["default"])({
    color: "var(--ci-text-color)",
    marginTop: "1px",
    wordBreak: "break-word",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "16px",
    letterSpacing: "0em",
    textAlign: "left",
    whiteSpace: "pre-wrap",
    p: {
      margin: 0
    }
  }, (_theme$message4 = theme.message) === null || _theme$message4 === void 0 ? void 0 : _theme$message4.textElement);
});

exports.TextElement = TextElement;

var ActionElement = _styledComponents["default"].button.withConfig({
  displayName: "styled__ActionElement",
  componentId: "sc-16x2xpi-6"
})(function (_ref6) {
  var _theme$brand3, _theme$brand3$colors, _theme$message5;

  var theme = _ref6.theme,
      primary = _ref6.primary,
      backgroundColor = _ref6.backgroundColor;
  var primaryColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme === null || theme === void 0 ? void 0 : (_theme$brand3 = theme.brand) === null || _theme$brand3 === void 0 ? void 0 : (_theme$brand3$colors = _theme$brand3.colors) === null || _theme$brand3$colors === void 0 ? void 0 : _theme$brand3$colors.primary;
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  return (0, _deepExtend["default"])({
    borderRadius: 6,
    color: primary ? "white" : "rgba(28, 39, 58, 1)",
    background: primary ? primaryColor : "white",
    wordBreak: "break-word",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "16px",
    height: "24px",
    padding: "0 16px",
    cursor: "pointer",
    border: "1px solid ".concat(primary ? "transparent" : "rgba(28, 39, 58, 1)"),
    marginRight: "12px",
    marginTop: "6px",
    transition: "all 100ms ease-in",
    "&:hover": {
      color: "white",
      background: primary ? tcPrimaryColor.lighten(10) : "rgba(28, 39, 58, 1)"
    }
  }, (_theme$message5 = theme.message) === null || _theme$message5 === void 0 ? void 0 : _theme$message5.actionElement);
});

exports.ActionElement = ActionElement;